module.exports = __webpack_public_path__ + "static/avatar-hb-5fb1c56cbfb5226259bffe654b3bd69a.png";